import { useEffect, useState } from 'react';
import { Grid, Button, Typography, TextField, Autocomplete, FormHelperText } from '@mui/material';
import useAuth from '../../hooks/useAuth';
import useCustomTranslation from 'hooks/useCustomTranslation';
import List from 'components/List';
import AlertDialog from 'AlertDialog';
import ActivityFormDialog from 'components/ActivityFormDialog';

function Admin() {
  const { getToken } = useAuth();
  const [activities, setActivities] = useState([]);
  const [prices, setPrices] = useState([]);
  const [type, setType] = useState([]);

  const [newActivity, setnewActivity] = useState(null);
  const [newActivitiesMerged, setNewActivitiesMerged] = useState([]);
  const [removedActivity, setRemovedActivity] = useState(null);
  const [editableActivity, setEditableActivity] = useState(null);

  const [loading, setLoading] = useState(false);
  const { t } = useCustomTranslation();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogContent, setDialogContent] = useState('');

  const [formOpen, setFormOpen] = useState(false);
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const [error, setError] = useState("");

  async function fetchActivities() {
    try {
      let url = `${process.env.REACT_APP_URL}/api/activity`;
      const token = await getToken();

      const headers = new Headers();

      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const result = await fetch(url, {
        method: 'GET',
        headers
      });
      if (result.ok) {
        const data = await result.json();
        setActivities(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchPrices() {
    try {
      let url = `${process.env.REACT_APP_URL}/api/activity/price`;
      const token = await getToken();

      const headers = new Headers();

      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const result = await fetch(url, {
        method: 'GET',
        headers
      });
      if (result.ok) {
        const data = await result.json();
        setPrices(data);
      }
    } catch (error) {
      console.error(error);
    }
  }
  async function handleAdd(newActivity, newPrice) {
    console.log(newActivity)
    console.log(newPrice)
    //if newActivity is empty
    if (!newActivity) {
      return;
    }

    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_URL}/api/activity`;
      const token = await getToken();

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify({ activity: newActivity, price: newPrice }),
      });

      if (response.ok) {
        setnewActivity(''); // Clear input on success
        fetchActivities(); // Refresh activities list
        setError();
      } else {
        console.error('Failed to add activity');
        setError(t('Failed to add activity.'));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  async function handleEdit(newName, newPrice) {
    console.log(editableActivity)
    console.log(newName)
    console.log(newPrice)
    //if newActivity is empty
    // if (!newActivity) {
    //   return;
    // }

    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_URL}/api/activity/` + editableActivity?.id;
      const token = await getToken();

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const response = await fetch(url, {
        method: 'PUT',
        headers,
        body: JSON.stringify({ activity: newName, price: newPrice }),
      });

      if (response.ok) {
        setEditableActivity(null)
        fetchActivities(); // Refresh activities list
        setError();
      } else {
        console.error('Failed to edit an activity');
        setError(t('Failed to edit an activity.'));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  async function confirmActivityRemove() {
    setDialogContent(t('Are you sure you want to remove this activity?'));
    setDialogTitle(t('Remove Activity'));
    setDialogOpen(true);
  }

  const editActivity = async () => {
    setType('edit')
    setFormOpen(true);
    setFormError('');
    setFormSuccess('');
  }

  const addActivity = async () => {
    console.log(newActivity)
    setType('add')
    setFormOpen(true);
    setFormError('');
    setFormSuccess('');
  }

  const handleConfirm = async () => {
    removeActivity()
  }

  const mergeActivities = async () => {
    console.log(newActivitiesMerged)
    setFormOpen(true);
    setType('merge');
    setFormError('');
    setFormSuccess('');
  }

  const handleMerge = async (newActivityName, newPrice) => {
    // Perform merging logic here (update state or API call)
    console.log("Merging activities:", newActivitiesMerged, "into", newActivityName);

    // Reset selection after merging
    // setSelectedActivities([]);

    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_URL}/api/activity/activities`;
      const token = await getToken();

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          newActivitiesMerged: newActivitiesMerged,
          newName: newActivityName,
          newPrice: newPrice
        }),
      });

      if (response.ok) {
        setnewActivity(''); // Clear input on success
        fetchActivities(); // Refresh activities list

        setDialogContent('');
        setDialogTitle('');

        setFormSuccess('Activities merged successfully');
        //add sleep 2s and then call setFormOpen(false)
        setTimeout(() => {
          setFormOpen(false);
          setNewActivitiesMerged([]);
          setnewActivity('');
          setFormError('');
          setFormSuccess('');
        }, 2000);
      } else {
        console.error('Failed to add activities');
        setFormError('Failed to merge activities.');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const removeActivity = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_URL}/api/activity/` + removedActivity?.id;
      const token = await getToken();

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);

      const response = await fetch(url, {
        method: 'DELETE',
        headers,
        body: JSON.stringify({ textInput: newActivity }),
      });

      if (response.ok) {
        setRemovedActivity(''); // Clear input on success
        //TODO: returns undefined after complete
        fetchActivities(); // Refresh activities list

        setDialogContent('');
        setDialogTitle('');

      } else {
        console.error('Failed to remove activities');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const handleNewActivityChange = (value) => {
    console.log(value);
    setnewActivity(value);
  };
  const handleMergedActivities = (value) => {
    console.log(value);
    setNewActivitiesMerged(value);
  };
  const handleRemovedActivity = (value) => {
    console.log(value);
    setRemovedActivity(value);
  };


  useEffect(() => {
    fetchActivities();
    fetchPrices();
  }, []);

  const getOnConfirmHandler = () => {
    switch (type) {
      case 'add':
        console.log('add');
        return handleAdd;
      case 'edit':
        console.log('edit');
        return handleEdit;
      case 'merge':
      default:
        console.log('merge');
        return handleMerge;
    }
  };


  return (
    <div>
      <Grid container spacing={2} mt={5}>
        <Grid item xs={12} md={8} sx={{ margin: 'auto' }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6">{t('Add New Activities')}</Typography>
              <Autocomplete
                id="add-activity"
                freeSolo
                value={newActivity}
                onChange={(event, newValue) => handleNewActivityChange(newValue)}
                onInputChange={(event, newValue) => handleNewActivityChange(newValue)}
                options={activities}
                getOptionLabel={(option) => {
                  // Handle both cases: option is an object or a string
                  if (typeof option === 'string') {
                    return option;
                  }
                  return option.activity || '';
                }}
                renderInput={(params) => <TextField {...params} label={t("Type an activity name")} />}
              />
              {error && <FormHelperText error>{error}</FormHelperText>}
              <Button
                variant="contained"
                color="primary"
                onClick={addActivity}
                disabled={loading}
                style={{ marginTop: '10px' }}
              >
                {loading ? t('Adding...') : t('Add Activity')}
              </Button>
              <Grid mt={5}>
                <Typography variant="h6">{t('Merge activities')}</Typography>
                <Autocomplete
                  id="merge-activities"
                  multiple
                  value={newActivitiesMerged}
                  onChange={(event, newValue) => handleMergedActivities(newValue)}
                  // onInputChange={(event, newValue) => handleMergedActivities(newValue)}
                  options={activities}
                  getOptionLabel={(option) => option.activity}
                  // options={activities.map((option) => option.activity + ' (' + option.id + ')')}
                  renderInput={(params) => <TextField {...params} label={t("Type an activity name")} />}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={mergeActivities}
                  disabled={loading}
                  style={{ marginTop: '10px' }}
                >
                  {t('Merge activities')}
                </Button>
              </Grid>
              <Grid mt={5}>
                <Typography variant="h6">{t('Remove an activity')}</Typography>
                <Autocomplete
                  id="remove-activity"
                  value={removedActivity}
                  onChange={(event, newValue) => handleRemovedActivity(newValue)}
                  options={activities}
                  getOptionLabel={(option) => option.activity}
                  renderInput={(params) => <TextField {...params} label={t("Type an activity name")} />}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={confirmActivityRemove}
                  disabled={loading}
                  style={{ marginTop: '10px' }}
                >
                  {t('Remove Activity')}
                </Button>
              </Grid>
              <Grid mt={5}>
                <Typography variant="h6">{t('Edit an activity')}</Typography>
                <Autocomplete
                  id="edit-activity"
                  value={editableActivity}
                  onChange={(event, newValue) => setEditableActivity(newValue)}
                  options={activities}
                  getOptionLabel={(option) => option.activity}
                  renderInput={(params) => <TextField {...params} label={t("Type an activity name")} />}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={editActivity}
                  disabled={loading}
                  style={{ marginTop: '10px' }}
                >
                  {t('Edit Activity')}
                </Button>
              </Grid>
            </Grid>

            {/* Right side: Display existing activities */}
            <Grid item xs={12} md={6} pb={30}>
              <Typography variant="h6">{t('All Activities')}</Typography>
              <List items={activities} name="activity" />
            </Grid>
          </Grid>
        </Grid>

      </Grid>
      <AlertDialog
        open={dialogOpen}
        setDialogOpen={setDialogOpen}
        handleConfirm={handleConfirm}
        title={dialogTitle}
        content={dialogContent}
        localeFormat={t}
      />
      <ActivityFormDialog
        formOpen={formOpen}
        setFormOpen={setFormOpen}
        type={type}
        activities={newActivitiesMerged}
        activity={type == 'edit' ? editableActivity : newActivity}
        prices={prices}
        onConfirm={(newActivity, newPrice) => getOnConfirmHandler()(newActivity, newPrice)}
        formError={formError}
        formSuccess={formSuccess}
      />
    </div>
  );
}

export default Admin;
